import { useReducer, useState } from 'react';
import { PendingRespondent, SearchParams } from 'src/@types/pendingRespondentStatus';
import { usePendingRespondentApi } from 'src/api/usePendingRespondentApi';
import { actions, initialState, reducer } from '../utils/searchState';

export const useIdIssuanceManagementList = () => {
  const { getPendingRespondents } = usePendingRespondentApi();
  const [fetchResult, setFetchResult] = useState<{ rowData: PendingRespondent[]; page: number; totalPages: number }>({
    rowData: [],
    page: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState<PendingRespondent | undefined>(undefined);
  const [searchParams, dispatch] = useReducer(reducer, initialState);

  const fetchPendingRespondents = async (searchParams: SearchParams) => {
    try {
      setLoading(true);
      const response = await getPendingRespondents(searchParams);
      if (response) {
        setFetchResult({
          rowData: response.items,
          page: response.page,
          totalPages: response.totalPages,
        });
        dispatch(actions.setCurrentPage(response.page));
      }
    } catch (error) {
      // NOTE: エラー時は何もしない
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchPendingRespondents,
    searchParams,
    dispatch,
    fetchResult,
    loading,
    selectedUser,
    setSelectedUser,
  };
};
